// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container and Card Styles */
.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .card {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
  }
  
  .card-header {
    padding: 16px 24px;
    border-bottom: 1px solid #eee;
  }
  
  .card-header h2 {
    margin: 0;
    font-size: 1.25rem;
    color: #333;
  }
  
  .card-content {
    padding: 24px;
  }
  
  /* Form Styles */
  .form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
  
  .form-left, .form-right {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  
  .input-field {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
  }
  
  .textarea-field {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    min-height: 100px;
    resize: vertical;
    font-size: 14px;
  }
  
  .price-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  
  .upload-section {
    display: flex;
    gap: 16px;
  }
  
  .upload-label {
    flex: 1 1;
    padding: 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    background: #f8f8f8;
  }
  
  .upload-label:hover {
    background: #f0f0f0;
  }
  
  .file-input {
    display: none;
  }
  
  .select-field {
    flex: 1 1;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: white;
  }
  
  .image-preview {
    aspect-ratio: 1;
    width: 100%;
    position: relative;
    overflow: hidden;
    border-radius: 4px;
  }
  
  .image-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .button-primary {
    width: 100%;
    padding: 12px;
    background: #3b82f6;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }
  
  .button-primary:hover {
    background: #2563eb;
  }
  
  /* Table Styles */
  .table-container {
    overflow-x: auto;
  }
  
  .listings-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .listings-table th {
    text-align: left;
    padding: 12px;
    font-weight: 500;
    color: #666;
  }
  
  .listings-table td {
    padding: 12px;
    border-top: 1px solid #eee;
  }
  
  .action-buttons {
    display: flex;
    gap: 8px;
  }
  
  .icon-button {
    padding: 6px;
    background: none;
    border: none;
    cursor: pointer;
    color: #666;
    border-radius: 4px;
  }
  
  .icon-button:hover {
    background: #f0f0f0;
  }

  .image-preview {
    margin-top: 10px;
    text-align: center;
  }
  
  .image-preview img {
    max-width: 100%;
    height: auto;
    border: 2px solid #ccc;
  }
  
  .clear-preview {
    margin-top: 10px;
    padding: 5px 10px;
    background-color: #ff4444;
    color: white;
    border: none;
    cursor: pointer;
    font-size: 14px;
  }
  
  .clear-preview:hover {
    background-color: #ff2222;
  }

  .listing-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .listing-table th,
  .listing-table td {
    padding: 10px;
    border: 1px solid #ddd;
    text-align: left;
  }
  
  .listing-table th {
    background-color: #f4f4f4;
  }
  
  .action-button {
    background: none;
    border: none;
    cursor: pointer;
    margin: 0 5px;
  }
  
  .action-button:hover {
    color: #007bff;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/studentComponents/booksContentPage.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAO;IACP,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,iBAAiB;EACjB;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;EACf;;EAEA;IACE,cAAc;EAChB","sourcesContent":["/* Container and Card Styles */\n.container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n  }\n  \n  .card {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    margin-bottom: 24px;\n  }\n  \n  .card-header {\n    padding: 16px 24px;\n    border-bottom: 1px solid #eee;\n  }\n  \n  .card-header h2 {\n    margin: 0;\n    font-size: 1.25rem;\n    color: #333;\n  }\n  \n  .card-content {\n    padding: 24px;\n  }\n  \n  /* Form Styles */\n  .form-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n  }\n  \n  .form-left, .form-right {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .input-field {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n  }\n  \n  .textarea-field {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    min-height: 100px;\n    resize: vertical;\n    font-size: 14px;\n  }\n  \n  .price-group {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n  }\n  \n  .upload-section {\n    display: flex;\n    gap: 16px;\n  }\n  \n  .upload-label {\n    flex: 1;\n    padding: 16px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    text-align: center;\n    cursor: pointer;\n    background: #f8f8f8;\n  }\n  \n  .upload-label:hover {\n    background: #f0f0f0;\n  }\n  \n  .file-input {\n    display: none;\n  }\n  \n  .select-field {\n    flex: 1;\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    background: white;\n  }\n  \n  .image-preview {\n    aspect-ratio: 1;\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n    border-radius: 4px;\n  }\n  \n  .image-preview img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .button-primary {\n    width: 100%;\n    padding: 12px;\n    background: #3b82f6;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n  }\n  \n  .button-primary:hover {\n    background: #2563eb;\n  }\n  \n  /* Table Styles */\n  .table-container {\n    overflow-x: auto;\n  }\n  \n  .listings-table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .listings-table th {\n    text-align: left;\n    padding: 12px;\n    font-weight: 500;\n    color: #666;\n  }\n  \n  .listings-table td {\n    padding: 12px;\n    border-top: 1px solid #eee;\n  }\n  \n  .action-buttons {\n    display: flex;\n    gap: 8px;\n  }\n  \n  .icon-button {\n    padding: 6px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #666;\n    border-radius: 4px;\n  }\n  \n  .icon-button:hover {\n    background: #f0f0f0;\n  }\n\n  .image-preview {\n    margin-top: 10px;\n    text-align: center;\n  }\n  \n  .image-preview img {\n    max-width: 100%;\n    height: auto;\n    border: 2px solid #ccc;\n  }\n  \n  .clear-preview {\n    margin-top: 10px;\n    padding: 5px 10px;\n    background-color: #ff4444;\n    color: white;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n  }\n  \n  .clear-preview:hover {\n    background-color: #ff2222;\n  }\n\n  .listing-table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .listing-table th,\n  .listing-table td {\n    padding: 10px;\n    border: 1px solid #ddd;\n    text-align: left;\n  }\n  \n  .listing-table th {\n    background-color: #f4f4f4;\n  }\n  \n  .action-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    margin: 0 5px;\n  }\n  \n  .action-button:hover {\n    color: #007bff;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
